goog.provide('el8.util.base');

// Add here so that we always include it
goog.require('el8.util.validate');

el8.util.isMac = function() {
    return (navigator.platform.indexOf("Mac") !== -1);
};

// it's better to just check the device width, but the iPad has a border-line
// desktop width, so we can use this if we need to handle iPads too
el8.util.isMobileAgent = function() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent));
};

el8.util.isSafariAgent = function() {
    return (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1);
};

// returns true for version of IE older than 10.0
el8.util.isOldIeAgent = function() {
    return (navigator.userAgent.indexOf('MSIE') !== -1 && navigator.userAgent.indexOf('MSIE 10.') === -1);
};

// return true if the app supports this browser:
//  Safari for Mac (not iPhone), iPad, Firefox, or Chrome
el8.util.isAppCompatAgent = function() {
    return (el8.util.isMac() && el8.util.isSafariAgent()) ||
            navigator.userAgent.indexOf('iPad') !== -1 ||
            navigator.userAgent.indexOf('Firefox') !== -1 ||
            navigator.userAgent.indexOf('Chrome') !== -1;
};

el8.util.isNone = function(arg) {
    return (arg === null) || (arg === undefined) || (arg === '');
};

el8.util.observableVal = function() {
    var that = {};
    that._observers = [];
    that._itemObservers = [];
    that._realtimeObservers = [];
    that.addObserver = function(fn) { that._observers.push(fn); };
    that.addItemObserver = function(fn) { that._itemObservers.push(fn); };
    that.addRealtimeObserver = function(fn) { that._realtimeObservers.push(fn); };
    that.itemNotify = function(item) {
        for (var i=0; i<that._itemObservers.length; i++) {
            that._itemObservers[i](item);
        }
    };
    that.notify = function() {
        for( var i=0; i<that._observers.length; i++ ) {
            that._observers[i]();
        }
    };
    that.realtimeNotify = function(var_args) {
        for (var i=0; i<that._realtimeObservers.length; i++) {
            that._realtimeObservers[i].apply(this, arguments);
        }
    };
    return that;
};

// Convenient function for taking an array of objects and
// returning an array of mapped objects via argument function with name fnName.
// If mapFn argument not specified, default is asMap() method
// If objs argument is null, returns null
el8.util.getMappedObjects = function(objs, fnName) {
    var mapFn = fnName || 'asMap';

    if( objs === null ) {
        return null;

    } else {

        var result = [];
        for( var i=0; i<objs.length; i++ ) {
            result.push( objs[i][ mapFn ]() );
        }
        return result;
    }
};

el8.util.setOptKey = function(target, key, val) {
    if (val !== undefined && val !== null && val !== '') {
        target[key] = val;
        return true;
    }
    return false;
};


// Combines objects (key-value pairs) with preference for
// first argument's value if keys are defined in both objects
el8.util.combineObjects = function( a, b ) {
    var result = {};
    for( var bKey in b ) {
        if( b.hasOwnProperty( bKey ) ) {
            result[ bKey ] = b[ bKey ];
        }
    }
    for( var aKey in a ) {
        if( a.hasOwnProperty( aKey ) ) {
            result[ aKey ] = a[ aKey ];
        }
    }
    return result;
};

// Checks whether an object is empty
el8.util.isEmptyObj = function( obj ) {
    return $.isEmptyObject(obj);
};

el8.util.matchStringArrayElts = function( spec ) {
    var arr1 = spec.arr1 || [];
    var arr2 = spec.arr2 || [];
    var ignoreCase = ( spec.ignoreCase !== false ); // defaults to true
    var matchPartial = ( spec.matchPartial !== false ); // defaults to true
    var result = [];
    var elt1, elt2;
    for( var i=0; i<arr1.length; i++ ) {
        for( var j=0; j<arr2.length; j++ ) {
            if( ignoreCase ) {
                elt1 = arr1[i].toLowerCase();
                elt2 = arr2[j].toLowerCase();
            } else {
                elt1 = arr1[i];
                elt2 = arr2[j];
            }
            if( matchPartial ) {
                if( el8.util.matchStringArrayElts({
                    arr1: elt1.split(' '),
                    arr2: elt2.split(' '),
                    ignoreCase: ignoreCase,
                    matchPartial: false }).length > 0 ) {
                    result.push( arr1[i] );
                }
            } else {
                if( elt1 === elt2 ) {
                    result.push( arr1[i] );
                }
            }
        }
    }
    return result;
};

el8.util.isSameArray = function(arr1, arr2) {
    if (arr1.length !== arr2.length) { return false; }
    for (var i=0; i<arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
};

el8.util.randomInt = function() {
    return Math.floor(Math.random()*10000)+1; // between 1 and 10,000
};

el8.util.getUrlParam = function(name) {
    //borrowed from http://stackoverflow.com/questions/1403888/get-url-parameter-with-jquery
    return decodeURI(
        (new RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||['',''])[1]);
};

el8.util.keysFromCamelToUnderscore = function(obj) {
    if ($.isArray(obj)) {
        return obj.map(el8.util.keysFromCamelToUnderscore);
    } else if (!$.isPlainObject(obj)) {
        return obj;
    }
    var newObj = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            newObj[key.fromCamelToUnderscore()] =
                (typeof obj[key] === 'object') ? el8.util.keysFromCamelToUnderscore(obj[key]) : obj[key];
        }
    }
    return newObj;
};

el8.util.keysFromUnderscoreToCamel = function(obj) {
    if ($.isArray(obj)) {
        return obj.map(el8.util.keysFromUnderscoreToCamel);
    } else if (!$.isPlainObject(obj)) {
        return obj;
    }
    var newObj = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            newObj[key.fromUnderscoreToCamel()] =
                (typeof obj[key] === 'object') ? el8.util.keysFromUnderscoreToCamel(obj[key]) : obj[key];
        }
    }
    return newObj;
};

el8.util.generateRandomId = function() {
    return Math.floor(Math.random() * 1000000000000) + 1000000000000;
};
